import { NgModule } from '@angular/core';
import { CalendarModule as AngularCalendarModule } from 'angular-calendar';
import { SharedModule } from '../../../shared';
import { CalendarComponent } from './calendar.component';
import { CalendarMonthViewMiniComponent } from './month-view-mini';
import { CalendarListComponent } from './list';
import { CalendarEventsLimitFilterPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        AngularCalendarModule
    ],
    declarations: [
        CalendarComponent,
        CalendarMonthViewMiniComponent,
        CalendarListComponent,
        CalendarEventsLimitFilterPipe
    ],
    exports: [
        CalendarComponent,
        CalendarMonthViewMiniComponent,
        CalendarListComponent,
        CalendarEventsLimitFilterPipe
    ],
    providers: [
        CalendarEventsLimitFilterPipe
    ]
})
export class CalendarModule { }
